
import { IFooter } from '@/types/detailPages'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class DecoFooter extends Vue {
  @Prop() mainColor!: string

  get footer (): IFooter {
    const items = [
      {
        title: this.$gettext("Digital promotion funds"),
        url: 'https://www.hausdesstiftens.org/foerderfonds/'
      },
      {
        title: this.$gettext("Imprint"),
        url: "https://www.hausdesstiftens.org/rechtliches/impressum/"
      },
      {
        title: this.$gettext("Privacy Policy"),
        url: "https://www.hausdesstiftens.org/rechtliches/datenschutz/"
      },
      {
        title: this.$gettext("Cookie Settings"),
        url: "/cookie-settings/"
      }
    ]
    return {
      mainColor: this.mainColor,
      items
    }
  }

  get footerBgStyle() {
    // Convert hex color to rgba with 0.8 alpha
    const hex = this.footer.mainColor || '#000000'
    const rgba = this.hexToRgba(hex, 0.2)
    return { backgroundColor: rgba }
  }

  hexToRgba(hex: string, alpha: number) {
    let c = hex.replace('#', '')
    if (c.length === 3) {
      c = c.split('').map(x => x + x).join('')
    }
    const num = parseInt(c, 16)
    const r = (num >> 16) & 255
    const g = (num >> 8) & 255
    const b = num & 255
    return `rgba(${r},${g},${b},${alpha})`
  }
}
